export enum ErrorCode {
  UserAlreadyHasEntitlement = 55,
}
